<template>
  <header class="title-box">
    <h2 class="title-box_title">Artists</h2>
    <div class="title-box_right">
      <PublicSelect
        :items="sortData"
        :selected="selectedSort"
        @input="$emit('sort', $event.id)"
      ></PublicSelect>
      <FilterBlock
        class="filter--mobile-full"
        style="margin-left: 15px"
        :items="filters"
        :search="search"
        @open="$emit('open-filters', $event)"
        @selectFilter="$emit('select-filter', $event)"
        @apply="$emit('apply-filters')"
        @clear="$emit('clear-filters')"
        @changeSearch="$emit('change-search', $event)"
      ></FilterBlock>
      <ViewToggle
        @input="$emit('update-view', $event)"
        designtype="public"
        :viewType="viewType"
      ></ViewToggle>
    </div>
  </header>
</template>

<script>
import PublicSelect from "@/components/inputs/PublicSelect.vue";
import FilterBlock from "@/components/FilterPublic.vue";
import ViewToggle from "@/components/ViewToggle.vue";

export default {
  components: {
    PublicSelect,
    FilterBlock,
    ViewToggle,
  },
  props: {
    sortData: Array,
    selectedSort: [String, Number],
    filters: Array,
    search: String,
    viewType: String,
  },
};
</script>

<style lang="scss" scoped>
.title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  &_right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    @media screen and (max-width: $xs) {
      justify-content: space-between;
      .view,
      .form-control {
        order: 1;
      }
      .view {
        margin-left: 15px;
      }
      .filter {
        order: 2;
        margin-left: 0 !important;
        width: 100%;
      }
    }
  }
  &_title {
    font-size: 4rem;
    line-height: 5rem;
    @media screen and (max-width: $xs) {
      font-size: 3.5rem;
      line-height: 4.3rem;
      margin-bottom: 30px;
    }
  }
}
</style>

